module.exports = {
  "ids": {
    "alert-banner": {
      "mix-blend-mode": {
        "value": "multiply",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "filePath": "./src/tokens/alert-banner.json",
        "isSource": true,
        "original": {
          "value": "multiply",
          "nob": [
            "system",
            "component",
            "property"
          ]
        },
        "name": "IDS_ALERT_BANNER_MIX_BLEND_MODE",
        "attributes": {
          "system": "ids",
          "component": "alert-banner",
          "property": "mix-blend-mode"
        },
        "path": [
          "ids",
          "alert-banner",
          "mix-blend-mode"
        ]
      },
      "opacity": {
        "value": "0.5",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "filePath": "./src/tokens/alert-banner.json",
        "isSource": true,
        "original": {
          "value": "0.5",
          "nob": [
            "system",
            "component",
            "property"
          ]
        },
        "name": "IDS_ALERT_BANNER_OPACITY",
        "attributes": {
          "system": "ids",
          "component": "alert-banner",
          "property": "opacity"
        },
        "path": [
          "ids",
          "alert-banner",
          "opacity"
        ]
      },
      "color": {
        "value": "rgb(51, 30, 17)",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "filePath": "./src/tokens/alert-banner.json",
        "isSource": true,
        "original": {
          "value": "{ids.color.brown.200.value}",
          "nob": [
            "system",
            "component",
            "property"
          ]
        },
        "name": "IDS_ALERT_BANNER_COLOR",
        "attributes": {
          "system": "ids",
          "component": "alert-banner",
          "property": "color"
        },
        "path": [
          "ids",
          "alert-banner",
          "color"
        ]
      },
      "border-radius": {
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "0.375rem",
        "filePath": "./src/tokens/alert-banner.json",
        "isSource": true,
        "original": {
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "{ids.size.border-radius.md}"
        },
        "name": "IDS_ALERT_BANNER_BORDER_RADIUS",
        "attributes": {
          "system": "ids",
          "component": "alert-banner",
          "property": "border-radius"
        },
        "path": [
          "ids",
          "alert-banner",
          "border-radius"
        ]
      },
      "spacing": {
        "inset": {
          "type": "size",
          "value": "1.5rem",
          "nob": [
            "system",
            "component",
            "category",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "size",
            "value": "{ids.size.spacing.small.value}",
            "nob": [
              "system",
              "component",
              "category",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_SPACING_INSET",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "category": "spacing",
            "variant": "inset"
          },
          "path": [
            "ids",
            "alert-banner",
            "spacing",
            "inset"
          ]
        },
        "stack": {
          "inner": {
            "type": "size",
            "value": "0.5rem",
            "nob": [
              "system",
              "component",
              "category",
              "concept",
              "scale"
            ],
            "filePath": "./src/tokens/alert-banner.json",
            "isSource": true,
            "original": {
              "type": "size",
              "value": "{ids.size.8.value}",
              "nob": [
                "system",
                "component",
                "category",
                "concept",
                "scale"
              ]
            },
            "name": "IDS_ALERT_BANNER_SPACING_STACK_INNER",
            "attributes": {
              "system": "ids",
              "component": "alert-banner",
              "category": "spacing",
              "concept": "stack",
              "scale": "inner"
            },
            "path": [
              "ids",
              "alert-banner",
              "spacing",
              "stack",
              "inner"
            ]
          },
          "paragraph": {
            "type": "size",
            "value": "1rem",
            "nob": [
              "system",
              "component",
              "category",
              "concept",
              "scale"
            ],
            "filePath": "./src/tokens/alert-banner.json",
            "isSource": true,
            "original": {
              "type": "size",
              "value": "{ids.size.spacing.smaller.value}",
              "nob": [
                "system",
                "component",
                "category",
                "concept",
                "scale"
              ]
            },
            "name": "IDS_ALERT_BANNER_SPACING_STACK_PARAGRAPH",
            "attributes": {
              "system": "ids",
              "component": "alert-banner",
              "category": "spacing",
              "concept": "stack",
              "scale": "paragraph"
            },
            "path": [
              "ids",
              "alert-banner",
              "spacing",
              "stack",
              "paragraph"
            ]
          },
          "media-query": {
            "base": {
              "type": "size",
              "value": "2rem",
              "nob": [
                "system",
                "component",
                "category",
                "category",
                "scale"
              ],
              "filePath": "./src/tokens/alert-banner.json",
              "isSource": true,
              "original": {
                "type": "size",
                "value": "{ids.size.spacing.default.value}",
                "nob": [
                  "system",
                  "component",
                  "category",
                  "category",
                  "scale"
                ]
              },
              "name": "IDS_ALERT_BANNER_SPACING_STACK_MEDIA_QUERY_BASE",
              "attributes": {
                "system": "ids",
                "component": "alert-banner",
                "category": [
                  "spacing",
                  "stack"
                ],
                "scale": "media-query"
              },
              "path": [
                "ids",
                "alert-banner",
                "spacing",
                "stack",
                "media-query",
                "base"
              ]
            },
            "md": {
              "type": "size",
              "value": "4rem",
              "nob": [
                "system",
                "component",
                "category",
                "category",
                "scale"
              ],
              "filePath": "./src/tokens/alert-banner.json",
              "isSource": true,
              "original": {
                "type": "size",
                "value": "{ids.size.spacing.larger.value}",
                "nob": [
                  "system",
                  "component",
                  "category",
                  "category",
                  "scale"
                ]
              },
              "name": "IDS_ALERT_BANNER_SPACING_STACK_MEDIA_QUERY_MD",
              "attributes": {
                "system": "ids",
                "component": "alert-banner",
                "category": [
                  "spacing",
                  "stack"
                ],
                "scale": "media-query"
              },
              "path": [
                "ids",
                "alert-banner",
                "spacing",
                "stack",
                "media-query",
                "md"
              ]
            }
          }
        }
      },
      "background-color": {
        "default": {
          "type": "color",
          "value": "rgb(151, 226, 247)",
          "nob": [
            "system",
            "component",
            "property",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "color",
            "value": "{ids.color.light-blue.100.value}",
            "nob": [
              "system",
              "component",
              "property",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_BACKGROUND_COLOR_DEFAULT",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "property": "background-color",
            "variant": "default"
          },
          "path": [
            "ids",
            "alert-banner",
            "background-color",
            "default"
          ]
        },
        "info": {
          "type": "color",
          "value": "rgb(151, 226, 247)",
          "nob": [
            "system",
            "component",
            "property",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "color",
            "value": "{ids.color.light-blue.100.value}",
            "nob": [
              "system",
              "component",
              "property",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_BACKGROUND_COLOR_INFO",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "property": "background-color",
            "variant": "info"
          },
          "path": [
            "ids",
            "alert-banner",
            "background-color",
            "info"
          ]
        },
        "success": {
          "type": "color",
          "value": "rgb(181, 237, 232)",
          "nob": [
            "system",
            "component",
            "property",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "color",
            "value": "{ids.color.teal.100.value}",
            "nob": [
              "system",
              "component",
              "property",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_BACKGROUND_COLOR_SUCCESS",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "property": "background-color",
            "variant": "success"
          },
          "path": [
            "ids",
            "alert-banner",
            "background-color",
            "success"
          ]
        },
        "warning": {
          "type": "color",
          "value": "rgb(255, 224, 130)",
          "nob": [
            "system",
            "component",
            "property",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "color",
            "value": "{ids.color.yellow.100.value}",
            "nob": [
              "system",
              "component",
              "property",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_BACKGROUND_COLOR_WARNING",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "property": "background-color",
            "variant": "warning"
          },
          "path": [
            "ids",
            "alert-banner",
            "background-color",
            "warning"
          ]
        },
        "error": {
          "type": "color",
          "value": "rgb(255, 201, 166)",
          "nob": [
            "system",
            "component",
            "property",
            "variant"
          ],
          "filePath": "./src/tokens/alert-banner.json",
          "isSource": true,
          "original": {
            "type": "color",
            "value": "{ids.color.pink.100.value}",
            "nob": [
              "system",
              "component",
              "property",
              "variant"
            ]
          },
          "name": "IDS_ALERT_BANNER_BACKGROUND_COLOR_ERROR",
          "attributes": {
            "system": "ids",
            "component": "alert-banner",
            "property": "background-color",
            "variant": "error"
          },
          "path": [
            "ids",
            "alert-banner",
            "background-color",
            "error"
          ]
        }
      }
    }
  }
};
